
import { Button } from '@mui/material'
import SpaceSignBoard from '../../../../_metronic/assets/svg/SpaceSignBoard'
import { useNavigate } from 'react-router-dom'

const AccessDenied = () => {
    const navigate = useNavigate()
    return (
        <div className="h-100">
            <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                <SpaceSignBoard height={280} width={280} />

                <div className="mt-10 text-center">
                    <h3 className="mb-2">دسترسی ممنوع!</h3>
                    <p className="fs-6 mb-0">
                        شما اجازه ورود به این صفحه را ندارید
                    </p>
                    <Button className='mt-3' onClick={() => navigate('/dashboard')} variant="contained" size="large"> برگشت به خانه</Button>
                </div>
            </div>
        </div>
    )
}

export default AccessDenied
